export type SupportedLocale =
  | 'en-AU'
  | 'en-NZ'
  | 'en-SG'
  | 'en-US'
  | 'en-CA'
  | 'en-PH'
  | 'fil-PH'
  | 'fr-CA'
  | 'id-ID'
  | 'ms-MY'
  | 'zh-HK'
  | 'ja-JP'
  | 'th-TH'
  | 'vi-VN'
  | 'ko-KR';

export type TranslationNamespace =
  | 'common'
  | 'search'
  | 'company'
  | 'people'
  | 'crm'
  | 'subscription'
  | 'list'
  | 'settings'
  | 'browser-ext'
  | 'developer'
  | 'dynamic-labels';

export interface LocaleConfig {
  locale: SupportedLocale;
  label: string;
  currency: AvailableCurrencies;
  dateStyle: 'DD/MM/YYYY' | 'MM/DD/YYYY' | 'YYYY/MM/DD';
  country: AvailableCountries;
}

export const DEFAULT_LOCALE: SupportedLocale = 'en-AU';

export const ALL_NAMESPACES: TranslationNamespace[] = [
  'common',
  'search',
  'company',
  'people',
  'crm',
  'subscription',
  'list',
  'settings',
  'browser-ext',
  'developer',
  'dynamic-labels',
];
